import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("contrack_cookie_consent");
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("contrack_cookie_consent", new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md z-50 bg-white border border-line rounded-[14px] shadow-pop p-5">
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <h3 className="text-[14px] font-semibold text-night mb-1">{t("cookie.title")}</h3>
          <p className="text-[12px] text-muted">
            {t("cookie.text")}
          </p>
          <a href="/privacy" className="text-[12px] text-info hover:underline mt-1 inline-block">
            {t("cookie.personvern")}
          </a>
        </div>
        <button onClick={accept} className="p-1 hover:bg-black/[0.05] rounded" aria-label={t("common.lukk")}>
          <X className="w-4 h-4 text-faint" />
        </button>
      </div>
      <button
        onClick={accept}
        className="mt-3 w-full px-4 py-2 bg-night text-white rounded-[10px] text-[13px] font-semibold hover:brightness-125 transition"
      >
        {t("cookie.ok")}
      </button>
    </div>
  );
}
